function request({path, method, body, headers, options, query, origin} ) {

	const _headers = {...headers} || {};
	if ( options?.multipart ) {
	} else if (!options?.blob) {
		_headers['content-type'] = 'application/json';
	}
	let _body = body;

	if ( _body && !options?.multipart) {
		_body = JSON.stringify(_body);
	}

	let fullPath = (origin || window.location.origin) + path;
	if (query) {
		const sp = new URLSearchParams(query);
		sp.sort();
		fullPath += `?${sp.toString()}`;
	}

	const controller = new AbortController();

	const request = fetch(fullPath, { body:_body, headers:_headers, method, signal: controller.signal})
	.then((response) => {
		if (!response) Promise.reject(null);
		if (!response.ok) {
			const httpStatus = response.status;
			return response.json().then((json) => {
				return Promise.reject({ ...json, _httpStatus: httpStatus });
			}).catch( e => {
				console.error(`[baseApi] Cannot parse json response from ${method} ${path}, status:${httpStatus}`, e);
				throw e;
			});
		}

		if (response.status === 204) return null;

		if (options?.blob) {
			return response.blob();
		}

		return response.json()
		.catch( e => {
			console.error(`[baseApi] Cannot parse json response from ${method} ${path}, status:${response.status}`, e);
			throw e;
		});
	});

	return [request, controller];
}

const Api = {
	DELETE: (params) => request({...params, method:'DELETE'}),
	GET: (params) => request({...params, method:'GET'}),
	PATCH: (params) => request({...params, method:'PATCH'}),
	POST: (params) => request({...params, method:'POST'}),
	PUT: (params) => request({...params, method:'PUT'})
};

export default Api;
